import React, { useEffect } from 'react'
import { useSetRecoilState } from 'recoil'
import { GetRedesSociais, GetTheme, PortalLogout, GetProspectConfigs, UpdatePassword, GetClientNotifications, SaveNotificationToken, PortalContatoClientes } from '@/domain/usecases'
import { useProspectSettings, useThemeClient, useFirebaseNotifications } from '@/presentation/hooks'
import { InstallationSuggestion, Logout, NavigationDrawer, PhoneModal, SnackBarProvider, UpdatePasswordC, phoneModalNumberState, socialMediaState } from '@/presentation/components'
import * as GeneralState from '@/presentation/components/Atoms'

type RouterProps = {
  getTheme: GetTheme
  getRedesSociais: GetRedesSociais
  getProspectConfigs: GetProspectConfigs
  portalLogout: PortalLogout
  updatePassword: UpdatePassword
  saveNotificationToken: SaveNotificationToken
  getNotifications: GetClientNotifications
  getPortalContatoClientes: PortalContatoClientes
}

const Router: React.FC<RouterProps> = (props) => {
  const { setThemeClient } = useThemeClient()
  const { startConfig } = useProspectSettings()
  const firebaseNotifications = useFirebaseNotifications()
  const setSocialMedia = useSetRecoilState(socialMediaState)
  const setLoadingProspectConfigs = useSetRecoilState(GeneralState.isLoadingProspectConfigsState)
  const setPhoneModal = useSetRecoilState(phoneModalNumberState)

  useEffect(() => {
    void (!__DEV__ && window.location.protocol === 'https:' && firebaseNotifications.serviceWorkerRegistration())

    props.getTheme
      .get()
      .then(setThemeClient)
      .catch(console.error)

    props.getRedesSociais
      .getRedesSociais()
      .then((socialMedias) => {
        setSocialMedia(socialMedias)
        setPhoneModal(socialMedias.phone)
      })
      .catch(console.error)

    setLoadingProspectConfigs(true)
    props.getProspectConfigs
      .getAll()
      .then(startConfig)
      .catch(console.error)
      .finally(() => { setLoadingProspectConfigs(false) })
  }, [])

  return (
    <>
      <SnackBarProvider />
      <Logout
        portalLogout={props.portalLogout}
        getRedesSociais={props.getRedesSociais}
      />
      <UpdatePasswordC updatePassword={props.updatePassword} />
      <InstallationSuggestion />
      <NavigationDrawer
        getNotifications={props.getNotifications}
        saveNotificationToken={props.saveNotificationToken}
        getPortalContatoClientes={props.getPortalContatoClientes}
      />
      <PhoneModal />
    </>
  )
}

export default Router
